module.exports = __webpack_public_path__ + "static/img/10.8a77f18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/10.png
// module id = i2X0
// module chunks = 0